import { render, staticRenderFns } from "./KpiChartShowPage.vue?vue&type=template&id=ffb482b2&scoped=true&"
import script from "./KpiChartShowPage.vue?vue&type=script&lang=js&"
export * from "./KpiChartShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb482b2",
  null
  
)

export default component.exports